import React, { useState } from 'react';
import { useCookies } from 'react-cookie';

import { getTranslation, keys } from '../../../Resources/Translations';
import { RibbonItem } from '../../ReactComponents/RibbonItem/RibbonItem';
import { AlertRibbonProps } from './AlertRibbonProps.csharp';

interface IAlertRibbonProps extends AlertRibbonProps {
    onChange: (isVisible: boolean) => void;
}

export const AlertRibbon = React.forwardRef((props: IAlertRibbonProps, ref: React.Ref<HTMLDivElement>) => {
    const { onChange, dismissedAlertVersionCookieName, alertRibbon } = props;
    const [cookies, setCookie, removeCookie] = useCookies([dismissedAlertVersionCookieName]);
    const [isDisplayed, setIsDisplayed] = useState(!alertRibbon.isDismissed);

    const dismissAlertRibbon = () => {
        const expirationDate = new Date();
        expirationDate.setUTCHours(24, 0, 0, 0);
        setCookie(dismissedAlertVersionCookieName, alertRibbon.version, {
            path: '/',
            secure: true,
            expires: expirationDate
        });
        setIsDisplayed(false);
        onChange(false);
    };

    React.useEffect(() => {
        const isVisibleAfterVersionCheck = !alertRibbon.isDismissed || alertRibbon.version !== cookies[dismissedAlertVersionCookieName];

        if (alertRibbon.isDismissed && isVisibleAfterVersionCheck) {
            removeCookie(dismissedAlertVersionCookieName);
            setIsDisplayed(true);
            onChange(true);
        }
    }, []);

    return isDisplayed ? (
        <div className="AlertRibbon" ref={ref}>
            <div className="AlertRibbon__Content">
                <p className="AlertRibbon__TextWrapper">
                    <RibbonItem text={props.alertRibbon.text} size="big" />
                </p>
                <button
                    type="button"
                    className="AlertRibbon__CloseButton"
                    onClick={dismissAlertRibbon}
                    aria-label={getTranslation(keys['alertRibbon.close'])}
                />
            </div>
        </div>
    ) : null;
});
